import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { CText } from '../common';
import { FiPieChart, FiTrendingUp, FiStar } from 'react-icons/fi';
import routes from '../../utils/routes';

interface HeroSectionProps {
  userName?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ userName }) => {
  const colors = useAppSelector((state) => state.theme.theme);
  const navigate = useNavigate();

  // Get greeting based on time of day
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  const statCards = [
    {
      icon: FiPieChart,
      label: 'Portfolio',
      value: 'View',
      subtext: 'Track investments',
      route: routes.portfolio,
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      icon: FiTrendingUp,
      label: 'Market',
      value: 'Explore',
      subtext: 'Find companies',
      route: routes.market,
      gradient: 'from-green-500 to-emerald-500',
    },
    {
      icon: FiStar,
      label: 'Watchlist',
      value: 'Track',
      subtext: 'Your favorites',
      route: routes.watchListHomeCard,
      gradient: 'from-amber-500 to-orange-500',
    },
  ];

  return (
    <div className="mb-8">
      {/* Greeting */}
      <div className="mb-6">
        <h1 className="text-2xl lg:text-3xl font-bold gradient-text mb-1">
          {getGreeting()}, {userName || 'Investor'}!
        </h1>
        <CText type="r14" color={colors.grayScale500}>
          Smart investing starts here
        </CText>
      </div>

      {/* Quick Stats Cards */}
      <div className="grid grid-cols-3 gap-3 lg:gap-4">
        {statCards.map((card) => {
          const Icon = card.icon;
          return (
            <button
              key={card.label}
              onClick={() => navigate(card.route)}
              className="p-4 rounded-2xl text-left transition-all duration-200 hover:-translate-y-1 active:scale-95 card-shadow"
              style={{
                backgroundColor: colors.cardBackground || colors.inputBackground,
                border: `1px solid ${colors.borderColor}`,
              }}
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 bg-gradient-to-br ${card.gradient}`}
                style={{ boxShadow: colors.shadowGlow }}
              >
                {React.createElement(Icon as any, { size: 20, color: '#fff' })}
              </div>
              <CText type="M14" color={colors.textColor} style={{ fontWeight: 600 }}>
                {card.label}
              </CText>
              <CText type="r12" color={colors.grayScale500} style={{ marginTop: 2 }}>
                {card.subtext}
              </CText>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HeroSection;
